import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {t} from 'i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import InternalUserService from '../../services/InternalUserService';
import UserDialog from './UserDialog';
import YesNoDialog from '../../components/YesNoDialog';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Menu } from 'primereact';

class UserListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new InternalUserService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            statusOptions: [],
            roleOptions: [],
        };
        this.handleOpenNewUserDialog = this.handleOpenNewUserDialog.bind(this);
        this.handleOpenNewOfficeDialog = this.handleOpenNewOfficeDialog.bind(this);
        this.handleCloseUserDialog = this.handleCloseUserDialog.bind(this);
        this.handleOpenEditDialog = this.handleOpenEditDialog.bind(this);
        this.handleOpenRemoveDialog = this.handleOpenRemoveDialog.bind(this);
        this.hideDeleteDialog = this.hideDeleteDialog.bind(this);
        this.onRemoveAction = this.onRemoveAction.bind(this);
        this.userId = this.authService.getUserId();
    }
    getDataKey() {
        return 'id';
    }

    getListTitle() {
        return 'user.listTitle';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    updateSearchCriteria(criteria) {
        return {
            email: criteria.email,
            firstName: criteria.firstName,
            lastName: criteria.lastName,
            role: criteria.role,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            roles: criteria.roles,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria() {
        return {
            email: '',
            firstName: '',
            lastName: '',
            role: undefined,
            id: null,
            firstResult: 0,
            roles: [],
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,
        };
    }

    initializeFromBackend() {}

    getCriteriaName() {
        return 'user-list-sc';
    }

    getContainerListName() {
        return 'user-list-container';
    }
    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='email-sc'
                    name='email'
                    label={t('user.email')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.email}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                <CriteriaTextComponent
                    id='firstName-sc'
                    name='firstName'
                    label={t('user.firstName')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.firstName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                <CriteriaTextComponent
                    id='lastName-sc'
                    name='lastName'
                    label={t('user.lastName')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.lastName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
            </div>
        );
    }

    prepareColumns() {
        return [
            {field: 'email', header: t('user.email'), sortable: true},
            {field: 'firstName', header: t('user.firstName'), sortable: true},
            {field: 'lastName', header: t('user.lastName'), sortable: true},
            {field: 'role.name', header: t('user.role'), body: this.roleTemplate.bind(this)},
            {
                key: 'actions',
                header: t('global.action'),
                body: this.actionTemplate,
                className: 'table-column-action',
                float: 'center',
            },
        ];
    }
    roleTemplate(rowData) {
        return rowData.roles ? rowData.roles.map((r) => t(`UserRoleType.${r}`)).join(', ') : '';
    }
    breadCrumbItems() {
        return [{name: t('user.listName'), url: '/users-list'}];
    }
    prepareHeaderItems() {
        const {t} = this.props;
        return this.isUserInRole('ROLE_ADMINISTRATOR')
            ? [
                  {
                      label: t('user.addButton'),
                      onClick: this.handleOpenNewUserDialog,
                      type: 'BUTTON',
                      id: 'addUser',
                      className: 'float-left',
                      variant: 'white',
                      iconName: 'mdi-plus',
                      iconSide: 'left',
                  },
              ]
            : [];
    }

    actionTemplate(rowData) {
         const menuRef = React.createRef();
    
        const menuItems = [
            {
                label: t('user.details'),
                icon: 'pi pi-eye',
                command: () => this.handleOpenEditDialog(null, rowData.id)
            },
            rowData.id !== this.userId && {
                label: t('global.remove'),
                icon: 'pi pi-trash',
                command: () => this.handleOpenRemoveDialog(null, rowData.id),
                className: 'text-red'
            }
        ].filter(Boolean); // Usuwa `false` wartości jeśli warunek nie jest spełniony
    
        return (
            <div>
                <Menu model={menuItems} popup ref={menuRef} />
                <Button
                    icon="pi pi-ellipsis-v"
                    className="menu-items"
                    onClick={(event) => menuRef.current.toggle(event)}
                />
            </div>
        );
    }

    actionTemplate2(rowData) {
        return (
            <div>
                <ActionLink
                    className='p-link float-right'
                    handleClick={(e) => this.handleOpenEditDialog(e, rowData.id)}
                    variant='blue'
                    iconName='mdi-eye'
                    iconSide='left'
                    iconSize='mdi-24px'
                    iconColor='blue'
                />
                <ActionLink
                    className='p-link float-right'
                    handleClick={(e) => this.handleOpenRemoveDialog(e, rowData.id)}
                    variant='red'
                    iconName='mdi-trash-can'
                    iconSide='left'
                    iconSize='mdi-24px'
                    iconColor='red'
                    rendered={rowData.id !== this.userId}
                />
            </div>
        );
    }
    handleOpenNewOfficeDialog(e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogOfficeVisibile: true, dialogViewMode: 'NEW'});
    }

    handleOpenNewUserDialog(e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, dialogViewMode: 'NEW'});
    }
    handleOpenEditDialog(e, id) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, dialogViewMode: 'EDIT', elementId: id});
    }

    handleCloseUserDialog(e, callback) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: false, elementId: undefined}, () => {
            if (callback) callback();
        });
    }
    handleOpenRemoveDialog(e, idToRemove) {
        if (e) {
            e.preventDefault();
        }
        this.setState({removeDialog: true, idToRemove});
    }
    hideDeleteDialog(callBack) {
        this.setState({removeDialog: false, idToRemove: null}, () => {
            if (callBack) callBack();
        });
    }

    render() {
        return (
            <div className='container-fluid'>
                {this.state.dialogVisibile ? (
                    <UserDialog
                        style={{maxWidth: '800px'}}
                        roleOptions={this.state.roleUser}
                        elementId={this.state.elementId}
                        onHide={(e) => this.handleCloseUserDialog(e)}
                        visible={this.state.dialogVisibile}
                        viewMode={this.state.dialogViewMode}
                        afterSave={(e) =>
                            this.handleCloseUserDialog(e, () => {
                                this.readMessage();
                                this.refreshTable();
                                this.unblockUi();
                            })
                        }
                        handleError={(err) => {
                            this.handleCloseUserDialog(null, () => {
                                this.unblockUi();
                                this.showErrorMessage(err.message);
                            });
                        }}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        _isMounted={this._isMounted}
                        showErrorMessage={this.showErrorMessage}
                        showSuccessMessage={this.showSuccessMessage}
                    />
                ) : null}
                {this.state.removeDialog ? (
                    <YesNoDialog
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.onRemoveAction(() => {
                                    this.hideDeleteDialog(() => {
                                        this.showSuccessMessage(t('user.removeUserConfirmation'));
                                        this.refreshTable();
                                        this.unblockUi();
                                    });
                                });
                            } else {
                                this.hideDeleteDialog();
                            }
                        }}
                        visible={this.state.removeDialog}
                        header={t('user.removeDialogHeader')}
                        name='visible'
                        onHide={() => {
                            this.setState({removeDialog: false});
                        }}
                        yesButtonClassName='red-button'
                    >
                        {t('user.userRemoveConfirmation')}
                    </YesNoDialog>
                ) : null}
                {this.renderView()}
            </div>
        );
    }
    onRemoveAction(callback) {
        this.blockUi();
        this.service
            .remove(this.state.idToRemove)
            .then(() => {
                callback();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.unblockUi();
                this.hideDeleteDialog();
            });
    }
}

UserListContainer.defaultProps = {
    editUrl: '/user/edit',
    newUrl: '/user/create',
    detailsUrl: '/user/details',
    lazy: true,
};

UserListContainer.propTypes = {
    editUrl: PropTypes.string,
    detailsUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(UserListContainer));
